// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labelDivWidth[data-v-0245f9b8] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
